import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";
import { getPurchaseOrderChargeStatus } from "../../PurchaseOrder/Redux/thunk";

// get Grn
export const getGrn = createAsyncThunk("grn/getGrn", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getGrn({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all Grn
export const getAllGrn = createAsyncThunk("grn/getAllGrn", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllGrn();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("grn/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("grn/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("grn/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageGrn({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get PurchaseOrder AdditionalCharge List
export const getPurchaseOrderAdditionalChargeList = createAsyncThunk(
  "grn/getPurchaseOrderAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseOrderAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getGrnById = createAsyncThunk("grn/getGrnById", async (id, { dispatch, rejectWithValue }) => {
  try {
    const { data } = await API.getGrnById(id);

    // Dispatch getDocNumbering if branchId exists

    if (data?.data?.goodReceiptNotesDetails?.length > 0) {
      // get stock by id and branch
      const updatedDetailsPromises = data.data?.goodReceiptNotesDetails.map(async (detail) => {
        const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

        if (stockData.data?.length > 0) {
          return {
            ...detail,
            // availableStock stock from stockData
            availableStock: stockData.data[0]?.closingStock || "",
          };
        } else {
          return {
            ...detail,
            availableStock: 0,
          };
        }
      });

      const updatedDetails = await Promise.all(updatedDetailsPromises);
      return {
        ...data,

        data: {
          ...data.data,

          goodReceiptNotesDetails: updatedDetails,
        },
      };
    } else {
      return data;
    }
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get item by id

// export const getPurchaseOrderDetailsById = createAsyncThunk(
//   "grn/getPurchaseOrderDetailsById",
//   async (id, { rejectWithValue }) => {
//     try {
//       const { data } = await API.getPurchaseOrderDetailsById(id);

//       if (data?.data.purchaseOrderDetails?.length > 0) {
//         // get stock by id and branch
//         const updatedDetailsPromises = data.data?.purchaseOrderDetails.map(async (detail) => {
//           const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

//           if (stockData.data?.length > 0) {
//             return {
//               ...detail,
//               // availableStock stock from stockData
//               availableStock: stockData.data[0]?.closingStock || "",
//             };
//           } else {
//             return {
//               ...detail,
//               availableStock: 0,
//             };
//           }
//         });

//         const updatedDetails = await Promise.all(updatedDetailsPromises);
//         return { ...data, data: { ...data.data, purchaseOrderDetails: updatedDetails } };
//       } else {
//         return data;
//       }
//     } catch (error) {
//       return rejectWithValue(error?.response?.data?.message);
//     }
//   }
// );

export const getPurchaseOrderDetailsById = createAsyncThunk(
  "grn/getPurchaseOrderDetailsById",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      // Fetch purchase order details by ID
      const { data } = await API.getPurchaseOrderDetailsById(id);

      // Check if purchaseOrderDetails exist and have data
      if (data?.data.purchaseOrderDetails?.length > 0) {
        // Map through purchase order details and fetch stock data for each product
        const updatedDetailsPromises = data.data.purchaseOrderDetails.map(async (detail) => {
          try {
            // Fetch stock by product ID and branch ID
            const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id);

            // Check if stock data is available, if so assign availableStock; otherwise, set to 0
            return {
              ...detail,
              availableStock: stockData?.data?.length > 0 ? stockData.data[0]?.closingStock || 0 : 0,
            };
          } catch (error) {
            // In case of error during stock fetch, set availableStock to 0
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        // Wait for all stock data fetch promises to resolve
        const updatedDetails = await Promise.all(updatedDetailsPromises);

        // if purchaseOrderMainAdditionalChargeCost is empty
        if (data?.data?.purchaseOrderMainAdditionalChargeCost.length === 0) {
          // checking if grn charge status is available or not
          const chargeStatusResponse = await dispatch(getPurchaseOrderChargeStatus("grn"));

          // Check if getPurchaseOrderChargeStatus("grn") was successful (you can check if the response is true or based on specific response data)
          if (chargeStatusResponse?.payload?.success) {
            // If successful, dispatch getPurchaseOrderAdditionalChargeList
            const response = await dispatch(getPurchaseOrderAdditionalChargeList());

            // Return updated data with additionalCharges after the additional charge list is fetched
            return {
              ...data,
              data: {
                ...data.data,
                purchaseOrderDetails: updatedDetails,
                purchaseOrderMainAdditionalChargeCost: response.payload.data.map((charge) => {
                  return {
                    id: null,
                    additionalCharge: { ...charge },
                    amount: 0,
                    // branch: 5,
                    // partyAccount: null,
                  };
                }),
              },
            };
          }
        } else {
          return { ...data, data: { ...data.data, purchaseOrderDetails: updatedDetails } }; //
        }
      } else {
        // If no purchaseOrderDetails exist, just return the data as is
        return data;
      }
    } catch (error) {
      // In case of any errors
      return rejectWithValue(error?.response?.data?.message || "An error occurred");
    }
  }
);

// create Grn
export const createGrn = createAsyncThunk("grn/createGrn", async (data, { rejectWithValue }) => {
  const {
    name,
    goodReceiptNotesDetails,
    grnMainAdditionalChargeCost,
    grnNumber,
    partyInvoiceNo,
    voucherDateBs,
    voucherDate,

    refVoucher,
    termsOfDelivery,
    destination,
    deliveryThrough,
    deliveryDocNumber,
    find,
    ppnNumber,
    lcNumber,
    branch,
    purchaseOrderMain,
    partyAccount,
    termsOfDeliveryPayment,
    grnMainPartyDetails,
    grnMainVehicleDetail,

    discountAmount,
    grandTotal,
    vatAmount,
  } = data;
  try {
    const body = JSON.stringify({
      name,
      goodReceiptNotesDetails,
      grnMainAdditionalChargeCost,
      grnNumber,
      partyInvoiceNo,
      voucherDateBs,
      voucherDate,

      refVoucher,
      termsOfDelivery,
      destination,
      deliveryThrough,
      deliveryDocNumber,
      find,
      ppnNumber,
      lcNumber,
      branch,
      purchaseOrderMain,
      partyAccount,
      termsOfDeliveryPayment,
      grnMainPartyDetails,
      grnMainVehicleDetail,
      discountAmount,
      grandTotal,
      vatAmount,
    });
    const { data } = await API.createGrn(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateGrn = createAsyncThunk("grn/updateGrn", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const {
    name,
    goodReceiptNotesDetails,
    grnMainAdditionalChargeCost,
    grnNumber,
    partyInvoiceNo,
    voucherDateBs,
    voucherDate,

    refVoucher,
    termsOfDelivery,
    destination,
    deliveryThrough,
    deliveryDocNumber,
    find,
    ppnNumber,
    lcNumber,
    branch,
    purchaseOrderMain,
    partyAccount,
    termsOfDeliveryPayment,
    grnMainPartyDetails,
    grnMainVehicleDetail,
    discountAmount,
    grandTotal,
    vatAmount,
  } = values;
  try {
    const body = JSON.stringify({
      name,
      goodReceiptNotesDetails,
      grnMainAdditionalChargeCost,
      grnNumber,
      partyInvoiceNo,
      voucherDateBs,
      voucherDate,

      refVoucher,
      termsOfDelivery,
      destination,
      deliveryThrough,
      deliveryDocNumber,
      find,
      ppnNumber,
      lcNumber,
      branch,
      purchaseOrderMain,
      partyAccount,
      termsOfDeliveryPayment,
      grnMainPartyDetails,
      grnMainVehicleDetail,
      discountAmount,
      grandTotal,
      vatAmount,
    });
    const { data } = await API.updateGrn(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("grn/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
